<template>
	<div class="sa_container">
        <div class="title">隐私政策</div>
        <pre class="content">
更新日期：2026年06月20日
生效日期：2026年06月20日
“ShunFeng”是一款由顺峰互动（以下简称“我们”）提供服务的社交产品，本政策中所涉及的个人信息处理活动及保护均针对“ShunFeng”产品。为说明ShunFeng会如何收集、使用和存储你的个人信息及你享有何种权利，我们将通过本政策向你阐述相关适宜，其中要点如下：
1. 我们将逐一说明我们收集的个人信息类型及其对应的用途，以便你了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。
2. 当你使某些功能时，我们会在获得你的同意后，收集你的敏感个人信息。如你在使用发送位置类型消息功能时，我们会收集你的精确位置信息。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使你无法使用相关特定功能，但不影响你正常使用ShunFeng的其他功能。
3. 我们不会主动共享或转让你的个人信息至顺峰互动外的第三方。如存在其他共享或转让你的个人信息，或你需要我们将你的个人信息共享或转让至顺峰互动外的第三方情形时，我们会直接征得或确认第三方征得你对上述行为的明示同意，但法律法规另有规定或因保护用户权益或保护ShunFeng生态安全需要除外。此外，我们会评估对外提供信息的行为所具有的风险。
4. 我们不会主动从顺峰互动外的第三方获取你的个人信息。如为业务发展需要从第三方获取你的个人信息，我们会依法核实来源的合法性，或在获取前向你明示你个人信息的来源、类型及使用范围，如ShunFeng开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的相关个人信息前，征得你的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供信息的合法性。
5. 你可以通过本政策所列途径及方式查阅、更正、复制、删除你的个人信息，也可以清空消息、注销帐号等。
6. 为了在本政策下收集你的信息，或者向你提供服务、优化我们的服务以及保障你的帐号安全，我们将需要向你索取相关的权限；其中的敏感权限例如位置、摄像头、麦克风、相册等均不会默认开启，只有在你明确同意后我们才会在你同意的范围内调用或使用。对你已经向我们授权的相关权限，你也可以在手机“设置-权限管理”中查询我们已调用或使用的系统权限类型、使用目的，并进行统一管理。需要特别说明的是，我们获得具体某一项敏感权限并不代表我们必然会收集你的相关信息；即使我们已经获得敏感权限，也仅在必要范围内、并在你使用相关的服务或功能期间根据本政策来收集你的相关信息。如你想了解更加详尽的信息，请根据以下索引阅读相应章节：
1. 我们收集、使用的信息
2. 信息的存储
3. 信息安全
4. 你的权利
5. 变更
6. 未成年人保护
7. 其它
8. 联系我们
1.我们收集、使用的信息
我们收集个人信息遵守以下要求：
A）收集的个人信息应具有明确、合理、具体的个人信息处理目的；
B）收集的个人信息应限于实现处理目的所必要的最小范围；
C）应采取对个人权益影响最小的方式收集个人信息。
D）收集的个人信息应与处理目的直接相关；
E）应仅在用户使用业务功能期间，收集该业务功能所需的个人信息。
A.3 即时通信类
必要个人信息：注册用户电子邮箱。
使用要求：用于即时通信用户注册。根据上述规定，在你使用ShunFeng服务的过程中，我们会按照如下方式收集、使用你在使用服务时主动提供或因为使用服务而产生的信息：
1.1当你注册ShunFeng账号时，我们会收集、使用你的昵称、头像、电子邮箱，收集这些信息是为了帮助你完成ShunFeng注册和使用ShunFeng社交等功能，保护你ShunFeng帐号的安全。若你不提供这类信息，你可能无法正常使用我们的服务。你还可以根据自身需求选择填写性别、签名等信息。
1.2当你使用ShunFeng服务及切换到后台时，为保障你正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全，我们会收集、使用你的设备型号、传感器信息、操作系统、包括硬件序列号、设备 MAC 地址、软件列表、唯一设备识别码(如IMEI/Android ID/IDFA/OpenUDID/MAC地址/OAID/GUID/SIM卡IMSI信息等其他设备相关信息)等在内的描述个人常用设备基本情况的信息BSSID、登录IP地址、ShunFeng软件版本号、接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息等日志信息。同时，为了预防病毒、木马程序或其他恶意程序、网站，我们可能会收集运营商信息以及你设备安装的应用信息、正在运行的进程信息或设备内存中寄存的数据，以防止你的个人信息泄露。
1.3当你使用ShunFeng向好友发送地理位置消息时，我们会在获得你的自主选择同意后，收集你的位置信息（为实现定位功能，我们可能会收集、使用你附近的WIFI信息、你设备附近的基站ID即CellID）。该信息属于敏感信息，拒绝提供该信息可能会使你无法使用上述功能，或无法达到上述基于位置信息提供的相关服务拟达到的效果，但不影响你正常使用ShunFeng的其他功能。
1.4当你使用ShunFeng发送语音/视频/图片/文件消息等功能时，我们会请求你授权你的麦克风权限、摄像头权限、相册权限、存储权限。并会收集你的语音内容、图片视频信息、扫描信息等内容，因为是实现上述功能所必需的。
1.5你可以在你的个人资料中填写昵称、性别、个性签名等，这些信息将被上传并存储在我们的服务器中，以便你在其他设备上登录ShunFeng时使用相关信息。你也可以随时修改、删除相关信息。
1.6我们不会收集你的聊天记录。我们采用加密处理每条聊天消息内容。你在ShunFeng中的聊天记录会存储在你的终端设备，你可以自行自行备份、保留、删除。
1.7ShunFeng服务中的第三方服务由集成在内部的Tencent RTC、Getui Push等SDK和外部第三方主体提供，ShunFeng无法获得你在使用该类第三方服务时产生的信息。该信息属于敏感信息，拒绝提供该信息仅会使你无法使用上述第三方服务，但不影响你正常使用ShunFeng的功能。
1.8如果你联系我们的客服，我们可能需要你提供必要的个人信息进行身份验证，以保证你的帐号安全。为根据你的诉求提供服务，经过你的授权人工客服人员需要在你授权范围内查询或核验你的相关信息，我们将尽可能采取技术和管理措施保障你的信息安全和保密，并在必要范围内进行使用。我们可能还会保存你的联系方式（你使用的或主动提供的ShunFeng账号、邮箱账号或其他联系方式）、你与我们的通信记录和内容，以及其他必要信息，以便为你提供和记录客户服务。
1.9另外，根据相关法律法规及国家标准，以下情形中，我们可能会处理你的相关个人信息而无需征求你的授权同意：
a) 为个人信息处理者履行法定义务或法定职责所必需；
b) 为订立、履行你作为一方当事人的合同所必需；
c) 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
d) 依法在合理的范围内处理你自行公开或者其他已经合法公开的个人信息；
e) 法律、行政法规规定的其他情形。
1.10请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中告知收集、使用你的信息的处理规则，我们会通过页面提示、交互流程、网站公告等方式另行向你告知信息收集的内容、范围、目的及方式，以征得你的同意。
1.11为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，ICCID、Android ID、MEID、IMEI、设备序列号、你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息融合处理
1.12如我们使用你的个人信息，超出了你所授权的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。
1.13为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)行为将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
1.14当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。
1.15为了更好的为您服务，避免在您正常使用手机设备时打扰到您，ShunFeng需要获取您的手机通话记录权限进行分时段推送服务
1.16在您分享ShunFeng内容到第三方平台时，我们可能会收集您的应用安装列表信息。
2.信息的存储
2.1 信息存储的地点
我们会将收集的用户个人信息存储于中国香港。
如果你的个人信息存储地点从中国香港转移到其他地点的，我们将严格依照法律的规定执行。
2.2 信息存储的期限
一般而言，我们仅在为实现目的所必需的时间及法律、行政法规所规定的保存期限内保留你的个人信息，例如：
电子邮箱：无论你是通过电子邮箱注册还是已有ShunFeng帐号进行登录，若你需要使用ShunFeng服务，我们需要一直保存你的电子邮箱，以保证你正常使用该服务，当你注销ShunFeng帐户后，我们将依法删除相应的信息。
当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，并在合理的期限内删除你的个人信息或进行匿名化处理（所谓“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。）
3.信息安全
我们一直致力于保障用户的信息安全。为了防止信息的丢失、不当使用、篡改、未经授权的访问或披露，同时确保信息会用于正确用途，我们会从人工维护，技术层面和管理层面上采取相应的措施来保障信息安全。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用端到端非对称加密、双棘轮加密、匿名化处理等手段来保护你的个人信息。
我们通过不断提升的加密技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成信息端到端加密的工作；为了预防病毒、木马程序或其他恶意程序、网站，我们可能会了解你设备安装的应用信息、正在运行的进程信息或设备内存中寄存的数据；为了预防诈骗、盗号、仿冒他人等不法行为和进行安全检查可能会分析利用唯一设备标识符、登陆IP地址、操作日志、地理位置信息等数据，以便于采取安全措施或对用户进行安全提醒等。
我们建立专门的管理制度、操作流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。
若发生个人信息泄露等安全事件，我们会启动应急预案及补救措施，阻止安全事件扩大，并依法履行相关的报告及通知义务。
我们会尽全力保护你的个人信息。我们也请你理解，任何安全措施都无法做到无懈可击。
如果您的个人信息因安全漏洞而泄露，我们将根据适用法律及时通知您。如果该等安全漏洞是由于以下任何原因造成的，您特此同意我们在任何情况下均不承担责任：
a) 政府或司法机关根据适用法律、监管政策、行政或司法命令，或基于其他合法理由向我们获取数据；
b) 因您自己的行为或不作为，导致您的账户或密码被共享或泄露，从而导致任何个人信息的泄露或暴露；
c) 任何由于黑客攻击、计算机病毒、木马或其他网络犯罪行为，或系统故障、通讯故障，而造成的信息泄露，并且现有技术在商业上无法切实地阻止或抵御该等事件；
d) 在发生危及公共安全或他人生命、健康或财产安全的紧急情况时，您的信息可能会被披露以减轻情况。如果您的权利因此受到损害，您可以根据适用法律向该事件的受益人索赔；
e) 因不可抗力或其他不可归责于我们的原因而导致您的信息披露。
4.你的权利
在你使用ShunFeng期间，为了你可以更加便捷地查阅、更正、删除你的个人信息，同时保障你撤回对个人信息处理的同意及注销帐号的权利，我们在产品设计中为你提供了相应的操作设置，你可以参考下面的政策进行操作。
请注意，不同操作系统、ShunFeng软件的不同版本之间，操作设置可能存在差异；此外，为了优化你的使用体验，我们也可能对操作设置进行调整。故如下政策仅供参考，若你对行使相关权利的方式及途径仍有任何疑问的，你可以通过本规则第8条披露的方式与我们联系。
4.1 查询、复制个人信息
4.1.1 查阅头像、昵称（即“名字”，下同）、性别、个性签名、邮箱地址、我的二维码等基本信息：
1) 进入ShunFeng后，点击“我”；
2) 点击头像栏；
3) 进行个人信息查询访问。
4.1.2 切换主题：
1) 进入ShunFeng后，点击“我的”；
2) 点击“切换主题”；
3) 选择“主题模式”进行设置。
4.1.3 密聊管理：
1) 进入ShunFeng后，点击“我的”；
2) 点击“密聊管理”；
3) 点击“重置密码”、“找回密码”、“清空聊天记录设置”进行操作。
4.1.4 查阅密码管理、黑名单、存储空间：
1) 进入ShunFeng后，点击“我的”；
2) 点击“设置”；
3) 点击“帐号与安全”；
4) 进行信息查询访问。
4.2 删除个人信息
4.2.1 删除一对一全部聊天记录：
1) 进入ShunFeng后，打开对话，点击右上角“...”图标；
2) 点击“清空聊天记录”。
4.2.2 删除部分/全部聊天记录：
1) 进入ShunFeng后，打开对话，长按点击一条需要删除的消息；
2) 选择“删除”，删除此条消息；
3) 进入ShunFeng后，点击“我的”；
4) 点击“设置”；
5)点击“存储空间”；
6)点击“去清理”、“管理”删除缓存和聊天记录。
7)点击“清空聊天记录”删除全部聊天记录。
4.2.3 删除个性签名的基本信息（二维码、ID等无法修改或删除）：
1) 进入ShunFeng后，点击“我的”；
2) 点击头像栏；
3) 删除相关信息。
4.3 更正个人信息
4.3.1 更改头像、昵称、性别、个性签名：
1) 进入ShunFeng后，点击“我的”；
2) 点击头像栏；
3) 进行更正操作
4.3.2 更改登录密码：
1) 进入ShunFeng后，点击“我的”；
2) 点击“设置”；
3) 点击“密码管理”；
4) 进行更正操作。
4.4 销毁帐号
4.4.1 销毁ShunFeng帐号：
1) 进入ShunFeng后，点击“我的”；
2) 点击“设置”；
3) 点击“销毁账号”删除账号所有相关信息；
注：销毁操作不可逆转，当你销毁账号后，所有类型的账号数据信息皆无法找回；
5. 变更
我们可能会适时对本政策进行修订。当政策的条款发生重大变更时，我们会在你登录及版本更新时以推送通知、弹窗或其他符合法律要求的适当形式向你展示变更后的政策。如果您不同意或不再同意此类变更，请停止访问和使用平台或服务。强烈建议用户定期查看本政策，了解任何变更。
6. 未成年人保护
我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是18周岁以下的未成年人，在使用ShunFeng服务前，应事先取得你的家长或法定监护人的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过第8条中的联系方式与我们联系。
儿童安全标准
6.1、CSAE 防范标准公示
ShunFeng严格遵守 Google Play《儿童安全标准》，针对儿童性虐待和性剥削（CSAE）制定以下核心措施：
6.1.1. 禁止内容定义
明确禁止以下 CSAE 相关行为及内容：
- 传播儿童性剥削材料（CSAM），包括真实或合成的未成年人色情图像、视频；
- 以性目的诱导、招揽未成年人聊天或线下接触；
- 任何将未成年人性感化的虚构或非虚构内容；
- 组织或推动 CSAE 活动的群组、频道或用户账号。
6.1.2. 技术与审核机制
- 人工审核：专业审核团队 7×24 小时对高风险内容（如含未成年人肖像的敏感场景）进行验证，响应时效≤15 分钟；
- 内容隔离存储：疑似CSAM 内容在确认前加密隔离，避免扩散。
6.1.3. 用户举报与响应流程
- 应用内反馈入口：在“我 - 帮助&关于-问题反馈”；
- 举报处理路径：
① 用户提交举报→②系统自动标记内容→③审核团队优先处理（2 小时内响应）→④确认违规后：
  - 内容：立即删除并永久封禁传播渠道；
  - 账号：实施阶梯处罚（首次警告→多次永久封号）；
  - 法律：同步向 NCMEC、本地执法机构提交证据包（含 IP、设备信息）。
6.2、合规义务履行
6.21. 儿童安全法遵循
- 年龄验证机制：新用户注册时提示“未满18周岁的用户必须取得监护人同意或年满18周岁”；
6.3、第三方协作与持续优化
- 行业联盟合作：遵循《打击线上 CSEA 最佳实践》，定期同步 CSAM 哈希库；
- 政策迭代机制：每季度根据 Google Play 政策更新、NCMEC 指南调整防范策略，并通过应用内公告向用户公示变更内容。
7. 其他
在ShunFeng某些具体服务或功能项下，我们可能还会通过交互文案、产品界面或弹窗等方式向你另行告知处理个人信息的目的、方式或范围，若另行告知的内容与本政策不一致的，以另行告知的内容为准。
（正文完）
顺峰互动
        </pre>
    </div>
</template>

<script>
export default {
	name      : 'PrivacyPolicyPc',
	components: {

	},

	data() {
		return {
            
		};
	},

	mounted() {
		window.scrollTo(0, 0);
	}
}
</script>

<style lang="less" scoped>
.sa_container {
	width: 100%;
	min-height: 100vh;
	box-sizing: border-box;
	padding: 100px 24px 60px;
	position: relative;

	.title {
		position: static;
		width: 100%;
		max-width: var(--com-base-container-w);
		height: auto;
		line-height: 1.5;
		margin: 0 auto 40px;
		font-family: var(--com-number-coin-fm-B) !important;
		font-size: var(--com-base-fz-32);
		color: #333;
		text-align: center;
	}

	.content {
		display: block;
		position: static;
		width: 100%;
		max-width: var(--com-base-container-w);
		height: auto;
		line-height: 2;
		margin: 0 auto;
		overflow: visible;
		font-family: inherit;
		font-size: var(--com-base-fz-14);
		color: #333;
		white-space: pre-wrap;
		word-break: break-word;
		overflow-wrap: anywhere;
	}
}

@media screen and (max-width: 768px) {
	.sa_container {
		padding: 64px 16px 36px;

		.title {
			margin-bottom: 18px;
			font-size: 28px;
			line-height: 1.4;
		}

		.content {
			font-size: 24px;
			line-height: 1.8;
		}
	}
}
</style>
